import _get from 'lodash/get'
import _cloneDeep from 'lodash/cloneDeep'

export const get_event_orders = state => _get(state, 'orders.orders', [])
export const get_event_orders_state = state => _cloneDeep(_get(state, 'orders'))
